/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <div class="product-listing" :class="columnClass">
    <div v-for="(product, index) in products" :key="index" class="wrapp-single-item" :id="product.sku">
      <product-tile :product="product" :listIndex="index" />
    </div>
  </div>
</template>

<script>
import ProductTile from './ProductTile'

export default {
  props: {
    products: {
      type: Array,
      required: true
    }
  },
  computed: {
    getColumnView () {
      return this.$store.getters['listing/getColumnView']
    },
    columnClass () {
      return [`column-view-${this.getColumnView}`]
    }
  },
  components: {
    ProductTile
  }
}
</script>
